import React from 'react'
import PropTypes from 'prop-types'
import { IN_CA, IN_AU, TIMEZONES, LOCALIZATION } from '../../utils/constants'

import { Container, VipHeadline, Title, Deal } from './styles'

const DiscountBanner = ({ discount, deal }) => (
  <Container>
    <VipHeadline>MOTHER'S DAY SALE:</VipHeadline>
    <Title>Save On Top-Rated {discount}</Title>
    <Deal>
      {deal ||
        `Discount automatically applied at checkout. Ends ${
          IN_CA || IN_AU ? '5/11' : '5/4'
        } at 11:59pm ${TIMEZONES[LOCALIZATION]} or while supplies last.`}
    </Deal>
  </Container>
)

DiscountBanner.propTypes = {
  deal: PropTypes.string,
  discount: PropTypes.string,
}

export default DiscountBanner
